
import { Badge } from "@/components/ui/badge";

interface ProductColorIndicatorBadgeProps {
  selectedColor?: any;
}

export const ProductColorIndicatorBadge = ({ selectedColor }: ProductColorIndicatorBadgeProps) => {
  // Only show badge if selectedColor exists and is not null
  if (!selectedColor || selectedColor === null) return null;

  return (
    <div className="absolute top-4 left-4 z-20">
      <Badge 
        variant="secondary" 
        className="bg-white/90 backdrop-blur-sm text-gray-800 border flex items-center gap-2"
      >
        <div
          className="w-3 h-3 rounded-full border border-gray-300"
          style={{ backgroundColor: selectedColor.hexColor }}
        />
        {selectedColor.name}
      </Badge>
    </div>
  );
};
